/**
 * Normalize profile percentage from API / session / store.
 * API often returns `{ percentage: number|null, ... }` instead of a bare number.
 * @param {unknown} value
 * @returns {number|null} numeric percentage, or null when missing/invalid
 */
export function resolveProfilePercentage(value) {
  if (value == null || value === "") {
    return null;
  }

  if (typeof value === "object") {
    return resolveProfilePercentage(value.percentage);
  }

  if (typeof value === "string" && value === "[object Object]") {
    return null;
  }

  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}
